import { render, staticRenderFns } from "./MasterdataBusMatrixEditModal.vue?vue&type=template&id=6c5e5f5a"
import script from "./MasterdataBusMatrixEditModal.vue?vue&type=script&lang=js"
export * from "./MasterdataBusMatrixEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports